import $ from 'jquery';
import Config from '@shopify/marketing-assets/javascripts/global/config';
import lazysizes from 'lazysizes/lazysizes';
import picturefill from 'picturefill';
import 'picturefill/src/plugins/intrinsic-dimension/pf.intrinsic';

import {
  A11yHelpers,
  AjaxEmailForm,
  CookiesNotice,
  Drawer,
  Flash,
  Nav,
  Popover,
  SocialShareButton,
  Subscribe,
} from '@shopify/marketing-assets';

export default function initializeMarketingAssets() {
  Config.set('customGoogleAnalyticsNamespace', '_exchange');
  picturefill();
  lazysizes.init();

  new Drawer('NavDrawer', 'right');
  new Nav();
  new Flash();
  new A11yHelpers();
  new CookiesNotice();

  $('.js-popover').each((i, el) => {
    new Popover($(el));
  });

  $('.js-social-share').each((i, el) => {
    new SocialShareButton($(el));
  });

  $('.js-ajax').each((i, el) => {
    new AjaxEmailForm($(el));
  });

  $('.js-subscribe').each((i, el) => {
    new Subscribe($(el));
  });
}
